"use client";

import type { ReactNode } from "react";
import { HotkeysProvider as ReactHotkeysProvider } from "react-hotkeys-hook";

export const HotkeysProvider = ({ children }: { children: ReactNode }) => {
	return <ReactHotkeysProvider>{children}</ReactHotkeysProvider>;
};
